import { LoginPage } from "./Login";

export { LoginPage };
